/**
 * iOS FCM topic bridge.
 *
 * The native Swift wrapper around the ExpatsSphere webview exposes a
 * WKScriptMessageHandler named `push-subscribe`. The wrapper accepts a
 * JSON payload of the form:
 *
 *   { "topic": "user_<userId>", "unsubscribe": false }
 *
 * On login: subscribe the device to `user_<userId>` so the backend can
 * publish per-user FCM messages to this device.
 * On logout: unsubscribe so notifications stop arriving for the previous user.
 *
 * Safely no-ops on web/Android/iOS-Safari (the handler only exists inside
 * the App Store wrapper).
 */

function getNativeHandler() {
  try {
    return (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers['push-subscribe']
    ) || null;
  } catch {
    return null;
  }
}

export function isNativeIOSApp() {
  return getNativeHandler() !== null;
}

export function subscribeUserToFcm(userId) {
  if (!userId) return false;
  const handler = getNativeHandler();
  if (!handler) return false;
  try {
    handler.postMessage(JSON.stringify({
      topic: `user_${userId}`,
      unsubscribe: false,
    }));
    return true;
  } catch (e) {
    console.warn('FCM subscribe bridge failed:', e);
    return false;
  }
}

export function unsubscribeUserFromFcm(userId) {
  if (!userId) return false;
  const handler = getNativeHandler();
  if (!handler) return false;
  try {
    handler.postMessage(JSON.stringify({
      topic: `user_${userId}`,
      unsubscribe: true,
    }));
    return true;
  } catch (e) {
    console.warn('FCM unsubscribe bridge failed:', e);
    return false;
  }
}
